import { render, staticRenderFns } from "./MsgClassifyManagerView.vue?vue&type=template&id=355c8ba0&scoped=true&"
import script from "./MsgClassifyManagerView.vue?vue&type=script&lang=js&"
export * from "./MsgClassifyManagerView.vue?vue&type=script&lang=js&"
import style0 from "./MsgClassifyManagerView.vue?vue&type=style&index=0&id=355c8ba0&lang=scss&scoped=true&"
import style1 from "./MsgClassifyManagerView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c8ba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355c8ba0')) {
      api.createRecord('355c8ba0', component.options)
    } else {
      api.reload('355c8ba0', component.options)
    }
    module.hot.accept("./MsgClassifyManagerView.vue?vue&type=template&id=355c8ba0&scoped=true&", function () {
      api.rerender('355c8ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMsgConfig/MsgClassifyManagerView.vue"
export default component.exports